<template>
  <div class="show-actions-container text-right">
    <slot></slot>
    <b-button class="show-action-btn mb-1" @click="$emit('clickOnDuplicateBtn')" variant="primary" v-if="duplicate">
      {{$t('Duplicate')}}
    </b-button>
    <b-button class="show-action-btn mb-1" @click="$emit('clickOnBoostBtn')" variant="primary" v-if="boost">
      {{$t('Boost')}} <star-icon size="18"/>
    </b-button>
    <b-button class="show-action-btn mb-1" @click="$emit('clickOnBoostBtn')" variant="outline-primary" v-if="unboost">
      {{$t('Unboost')}} <star-icon size="18"/>
    </b-button>
    <b-button class="show-action-btn resetPassword mb-1" @click="$emit('clickOnResetPasswordBtn')" v-if="resetPassword">
      <img class="btn-icon" :src="require(`@/assets/images/reset-password.svg`)" alt="reset password icon" height="18">
    </b-button>
    <b-button class="show-action-btn mb-1" @click="$emit('clickOnEditBtn')" variant="secondary" v-if="editItem">
      <pencil-icon size="18"/>
    </b-button>
    <b-button class="show-action-btn mb-1" @click="$emit('clickOnDeleteBtn')" variant="primary" v-if="deleteItem">
      <trash-icon size="18"/>
    </b-button>
    <b-button class="show-action-btn delete-forever mb-1" @click="$emit('clickOnDeleteBtn')" v-if="deleteForever">
      {{ $t('Delete.forever') }} <trash-icon size="18"/>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'ShowActions',

  props: {
    duplicate: {
      type: Boolean,
      default: false
    },
    boost: {
      type: Boolean,
      default: false
    },
    unboost: {
      type: Boolean,
      default: false
    },
    resetPassword: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Boolean,
      default: true
    },
    deleteItem: {
      type: Boolean,
      default: true
    },
    deleteForever: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

.show-actions-container {
  min-width: 80px;
  gap: 10px;
}
.show-action-btn {
  padding: 8px 12px;
}

.delete-forever {
  background-color: black;
  border-color: black;
  color: white;
}

.delete-forever:hover {
  background-color: var(--secondary-text-color) !important;
  border-color: var(--secondary-text-color);
  color: white !important;
}

.resetPassword {
  background-color: var(--main-text-color);
}
.resetPassword:hover {
  background-color: var(--main-grey);
}

</style>



// WEBPACK FOOTER //
// src/components/b122/ShowActions.vue